export default __webpack_public_path__ + "static/media/url.a968cce9.jpg";